/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type AgentJobStatusEnum = 'NEW' | 'COMPLETED' | 'FAILED' | 'REJECTED';

export const AgentJobStatusEnum = {

    NEW: 'NEW' as AgentJobStatusEnum,

    COMPLETED: 'COMPLETED' as AgentJobStatusEnum,

    FAILED: 'FAILED' as AgentJobStatusEnum,

    REJECTED: 'REJECTED' as AgentJobStatusEnum
};

